var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"wa-msg-text"},_vm._l((_vm.parts),function(part,i){return _c('span',{key:i,class:{ 'wa-msg-blank': part.blank }},[_vm._v(_vm._s(part.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }